"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { compressVideoOperation } from "../_operations/compressVideo";

export function CompressVideoContent() {
  return <MediaWorkspace operation={compressVideoOperation} />;
}
